import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const BetWrightLogo = ({ className }: PropsType): React.ReactElement => (
    <SvgElement
        xmlns='http://www.w3.org/2000/svg'
        width='264'
        height='36'
        fill='none'
        viewBox='0 0 264 36'
        className={className}
    >
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='264'
            height='36'
            fill='none'
            viewBox='0 0 264 36'
        >
            <path
                fill='#1A2126'
                d='m109.408.574 6.564 25.11 6.043-25.11h8.335l-9.897 34.749h-7.867l-6.095-23.861-6.044 23.86h-7.866L82.631.575h8.282l6.096 25.11 6.617-25.11M148.428 22.088c3.75-.886 7.606-4.167 7.606-10.314 0-6.461-4.428-11.202-11.671-11.202h-11.928l-4.324 15.183v19.566h7.397V22.87h5.419l6.824 12.45h8.491l-7.814-13.233Zm-5.159-5.573h-7.763V6.929h7.763c2.971 0 5.21 1.876 5.21 4.793 0 2.917-2.239 4.793-5.21 4.793ZM157.497.574v28.64l3.608 6.107h3.79V.574h-7.398ZM183.437 22.505h9.247v4.219c-1.511 1.354-4.324 2.656-7.503 2.656-6.304 0-10.888-4.844-10.888-11.408 0-6.564 4.584-11.408 10.888-11.408a9.864 9.864 0 0 1 8.232 4.376l6.146-3.334C196.903 3.49 192.37 0 185.181 0c-10.16 0-18.494 6.98-18.494 17.974S175.021 36 185.181 36c6.304 0 11.253-2.605 14.795-6.564V16.152l-14.935-.112M225.792 20.734h-16.409V35.32h-7.398V.574h7.398v13.65h16.409V.574h7.45v34.749h-7.45V20.734ZM262.925.607V.574h-.033l.033.033ZM262.847.574h-27.638v6.512h10.159v28.235h7.45V7.086h10.108l-3.185-3.406 3.106-3.106Z'
            />
            <path
                fill='#FFCE00'
                d='M82.643 7.086H75.51v28.235h-7.45V6.855H57.905v-.048L54.746 3.71l3.158-3.1V.572H80.78l1.864 6.514Z'
            />
            <path
                fill='#FFCE00'
                d='M55.324 6.97v-.65l-2.662-2.61 2.662-2.614v-.48h-24.59v34.746h24.59v-6.407H38.132v-8.074H54.96v-6.356H38.132V6.971h17.192ZM22.297 17.407c3.282-.677 5.992-3.596 5.992-7.972 0-4.636-3.387-8.857-10.003-8.857H0V.65l3.12 3.06L0 6.773V35.33h18.86c6.615 0 10.106-4.167 10.106-9.377 0-4.376-2.97-7.972-6.67-8.543v-.002ZM7.398 6.884h9.274c2.5 0 4.064 1.668 4.064 3.804s-1.562 3.856-4.064 3.856H7.398v-7.66Zm9.534 22.141H7.398v-8.18h9.534c2.917 0 4.481 1.877 4.481 4.065 0 2.501-1.668 4.115-4.48 4.115Z'
            />
        </svg>
    </SvgElement>
);
